import React, { useEffect } from "react";
import { useRecoilValue } from "recoil";
import { currentJobLevel } from "../../atoms/dashboard";
import upcomingSvg from "../../images/svg/upcoming.svg";
import { randomUUID } from "../../utils/randomUUID";
import PopOver from "../PopOver/PopOver";

const Tab = (props) => {
  const jobLevelData = useRecoilValue(currentJobLevel);

  console.log("jobLevelData", jobLevelData);

  useEffect(() => {
    let bindAll = function() {
      // for my role-journey-team
      let tabLink = document.getElementsByClassName("tab-nav");
      let tabMenus = tabLink[0]?.querySelectorAll("button");
      let tabContent = document.getElementsByClassName("tab-content");
      for (let i = 0; i < tabMenus?.length; i++) {
        tabMenus[i].addEventListener("click", change, false);
        if (i == 0) {
          tabMenus[i].querySelector(".role-span").classList.add("active");
          tabMenus[i].classList.add("active");
          tabContent[0].childNodes[i].classList.add("active");
        }
      }
    };

    let clear = function() {
      let tabLink = document.getElementsByClassName("tab-nav");
      let tabMenus = tabLink[0].querySelectorAll("button");
      let tabContent = document.getElementsByClassName("tab-content");
      let tabContInner = tabContent[0].childNodes;
      for (let i = 0; i < tabMenus.length; i++) {
        tabMenus[i].querySelector(".role-span").classList.remove("active");
        tabMenus[i]?.classList.remove("active");
        tabContInner[i]?.classList.remove("active");
      }
    };

    function getElementIndex(el) {
      return [...el.parentElement.children].indexOf(el);
    }

    const change = function(e) {
      clear();
      let getIdx = getElementIndex(e.target.closest("button"));
      let tabLink = document.getElementsByClassName("tab-nav");
      let tabMenus = tabLink[0].querySelectorAll("button");
      let tabContent = document.getElementsByClassName("tab-content");
      let tabContInner = tabContent[0].childNodes;
      tabMenus[getIdx].querySelector(".role-span").classList.add("active");
      tabMenus[getIdx].classList.add("active");
      tabContInner[getIdx].classList.add("active");
    };

    bindAll();
  });

  return (
    <div
      className={
        jobLevelData == "upcoming"
          ? "future-data my-role tab-main h-full"
          : "my-role tab-main h-full"
      }
    >
      <nav
        className={`-mb-px flex space-x-8 tab-nav ${props?.data?.menuClassName}`}
        aria-label="Tabs"
      >
        {props?.data?.title?.map((title, idx) => {
          return (
            <button
              key={randomUUID()}
              className={`border-transparent  group inline-flex items-center py-4 pl-6 !ml-0 !mr-0 tab-button ${title ==
                "My Role" && "my-role-border"} ${title ? title : "ntg-class"}`}
            >
              <span
                className={`${
                  props.data?.menuClassName == "my-tabs"
                    ? "h-4 w-5 bg-white flex items-center justify-center p-4 mr-2 rounded-full"
                    : ""
                } role-span`}
              >
                <span
                  dangerouslySetInnerHTML={{ __html: props?.data?.icon[idx] }}
                  className="stroke-gray-100 fill-[#418aff]"
                />
              </span>
              <PopOver
                content={title}
                direction={
                  jobLevelData == "upcoming" && title == "My Role"
                    ? "left"
                    : "bottom"
                }
              >
                <span
                  className={`${
                    !title ? "empty-line" : ""
                  } flex gap-3 uppercase`}
                >
                  {title ? title : ""}
                </span>
              </PopOver>
            </button>
          );
        })}
      </nav>
      <div className={`tab-content ${props?.data?.contentParentClassName}`}>
        {props?.data?.content?.map((content, idx) => {
          return (
            <div
              key={randomUUID()}
              className={`${props?.data?.contentClassName[idx]}`}
            >
              {content}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Tab;
